module.exports = __webpack_public_path__ + "img/Қызылорда облысы.b5e4dcf9.png";